module.exports = __webpack_public_path__ + "134dcd01ceaca24225c3554a693b8cb0.svg";